import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import { DebounceInputSearch, UFInput } from "../../../components/Common/Fields/Input"
import Status from "../../../components/Common/chooseFields/status"
import { useForm } from "react-hook-form"
import { Form } from "reactstrap"
import exportIcon from "../../../assets/icons/export.svg"
import {
  importFileData,
  sampleFileDownload,
} from "../../../services/Inventory/inventory"
import closeIcon from "../../../assets/icons/close.svg"
import uploadicon from "../../../assets/icons/import.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import CustomerType from "../../../components/Common/chooseFields/customerType"
import LoadingButton from "../../../components/Common/LoadingButton"
import resetIcon from "../../../assets/icons/reset.svg"
import ProjectNo from "../../../components/Common/chooseFields/projectno"
import Location from "../../../components/Common/chooseFields/location"
import Customer from "../../../components/Common/chooseFields/customer"
const CustomerFilter = ({
  handleStatusChange,
  handleSearchChange,
  handleCatChange,
  handleProjectCode,
  handleLocationId,
  handleCustomerCode,
  sampleUrl,
  importUrl,
  isImport,
}) => {
  const [modal, setModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const { control, watch, reset } = useForm()

  const toggle = () => {
    setModal(!modal)
    setFile()
    setFileName()
  }

  const handleStatus = data => {
    handleStatusChange(data?.value)
  }

  const handleCat = data => {
    handleCatChange(data?.id)
  }

  const handleSampleFile = () => {
    const handleCommonExport = async () => {
      const response = await sampleFileDownload(sampleUrl)
    }
    handleCommonExport()
  }

  useEffect(() => {
    handleSearchChange(watch("search"))
  }, [watch("search")])

  const [file, setFile] = useState()
  const [fileName, setFileName] = useState()

  const onFileChange = event => {
    setFileName(event)
    setFile(event?.target?.files?.[0])
  }

  const handleImport = () => {
    const importFile = async () => {
      try {
        setIsLoading(true)
        const response = await importFileData({
          importfile: file,
          url: importUrl,
        })
        toastSuccess(response?.message)
        setModal(false)
      } catch (err) {
        toastError(err?.message)
      } finally {
        setIsLoading(false)
      }
    }
    importFile()
  }

  const handlePorjectChange = data => {
    handleProjectCode(data?.label)
  }

  const handleLocation = data => {
    handleLocationId(data?.id)
  }

  const handleCodeChange = data => {
    handleCustomerCode(data?.id)
  }

  const handleReset = () => {
    handlePorjectChange()
    handleStatusChange()
    handleSearchChange()
    handleCatChange()
    handleLocation()
    handleCodeChange()
    reset({
      search: "",
      customer_type: null,
      status: null,
      project_code: null,
      location_id: null,
      client_code: null,
    })
  }
  return (
    <>
      <div className="d-flex justify-content-between align-items-center my-2 me-2">
        <Form id="user-form" className="filter-wrapper">
          <Row className="mx-0">
            <Col sm={3} className="pe-1">
              <ProjectNo
                control={control}
                placeholder="Project Code"
                name={"project_code"}
                target={"body"}
                onSelectChange={e => handlePorjectChange(e)}
              />
            </Col>
            {/* <Col sm={3} className="pe-1">
              <CustomerType
                control={control}
                name={"customer_type"}
                placeholder={"Customer Type"}
                target={"body"}
                onSelectChange={e => handleCat(e)}
              />
            </Col> */}
            <Col sm={3} className="pe-1">
              {/* <CustomerType
                control={control}
                name={"customer_type"}
                placeholder={"Customer Type"}
                target={"body"}
                onSelectChange={e => handleCat(e)}
              /> */}
              <Location
                control={control}
                placeholder="Project Location"
                name={"location_id"}
                target={"body"}
                onSelectChange={e => handleLocation(e)}
              />
            </Col>
            <Col sm={2} className="pe-1">
              <Customer
                control={control}
                placeholder="Customer"
                name={"client_code"}
                target={"body"}
                onSelectChange={e => handleCodeChange(e)}
              />
            </Col>
            <Col sm={2} className="pe-1">
              <Status
                control={control}
                name={"status"}
                onSelectChange={e => handleStatus(e)}
              />
            </Col>
          </Row>
        </Form>
        <div className="d-flex">
          <div
            className="export-div pointer me-2 reset-img"
            onClick={() => handleReset()}
          >
            <img src={resetIcon} height={15} width={15} className="me-2" />{" "}
            Reset
          </div>
          <DebounceInputSearch
            control={control}
            placeholder={"Search"}
            name={"search"}
            className={"search-input"}
            minLength={1}
            debounceTimeout={600}
          />
          {/* <UFInput
            control={control}
            placeholder="Search"
            name={"search"}
            className={"search-input"}
          /> */}
          {isImport && (
            <div className="export-div pointer" onClick={() => toggle()}>
              <img src={exportIcon} />
            </div>
          )}
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        <ModalHeader className="custom-modal-header">
          <div className="d-flex justify-content-between">
            <h5>{"Bulk Upload"}</h5>
            <img
              src={closeIcon}
              alt=""
              onClick={() => setModal(false)}
              width="10"
              role="button"
            />
          </div>
        </ModalHeader>

        <ModalBody>
          <div className="d-flex p-5 my-3">
            <Col className="file-import-div me-3 ">
              <label htmlFor="upload" className="m-0 pointer">
                <input
                  type="file"
                  id="upload"
                  name="upload"
                  accept=".xls,.xlsx"
                  onChange={event => {
                    onFileChange(event)
                  }}
                />
                {fileName ? (
                  <span>{fileName?.target?.files?.[0]?.name}</span>
                ) : (
                  <>
                    <img
                      src={uploadicon}
                      alt="Upload Excel"
                      className="upload-icon me-2 "
                    />
                    <span className="upload">Upload&nbsp;</span>
                    <span>the file</span>
                  </>
                )}
              </label>
            </Col>
            {/* <button
              className="btn btn-primary"
              type="submit"
              onClick={handleImport}
            >
              Import
            </button> */}
            <LoadingButton
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              className="btn btn-primary"
              type="submit"
              onClick={handleImport}
            >
              Import
            </LoadingButton>
          </div>
        </ModalBody>
        <ModalFooter className="bulk-upload-footer">
          <Row className="d-flex justify-content-center">
            <Col lg={8} className="text-center">
              Please download the sample file, add items, price etc & upload it
              back to create your Documents
            </Col>
          </Row>
          <Row
            className="fw-bold d-flex justify-content-center w-100 pointer"
            onClick={() => handleSampleFile()}
          >
            Download Sample File &gt;
          </Row>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default CustomerFilter
